var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSupport = function SvgSupport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.32 15.6C34.32 14.7389 33.6211 14.04 32.76 14.04C31.8989 14.04 31.2 14.7389 31.2 15.6C31.2 15.9713 31.2 26.9288 31.2 27.3C31.2 28.1612 31.8989 28.86 32.76 28.86C33.6211 28.86 34.32 28.1612 34.32 27.3C34.32 26.9288 34.32 15.9713 34.32 15.6Z",
    stroke: "#737C88",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.84 36.66C22.7011 36.66 23.4 35.9612 23.4 35.1C23.4 34.2389 22.7011 33.54 21.84 33.54C21.4687 33.54 18.3113 33.54 17.94 33.54C17.0789 33.54 16.38 34.2389 16.38 35.1C16.38 35.9612 17.0789 36.66 17.94 36.66C18.3113 36.66 21.4687 36.66 21.84 36.66Z",
    stroke: "#737C88",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24001 14.8201C6.24001 7.49664 12.1766 1.56006 19.5 1.56006C26.8234 1.56006 32.76 7.49664 32.76 14.8201",
    stroke: "#737C88",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.32 15.6C36.4744 15.6 38.22 18.2184 38.22 21.45C38.22 24.68 36.4744 27.3 34.32 27.3",
    stroke: "#737C88",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.67999 15.6C4.67999 14.7389 5.37887 14.04 6.23999 14.04C7.10111 14.04 7.79999 14.7389 7.79999 15.6C7.79999 15.9713 7.79999 26.9288 7.79999 27.3C7.79999 28.1612 7.10111 28.86 6.23999 28.86C5.37887 28.86 4.67999 28.1612 4.67999 27.3C4.67999 26.9288 4.67999 15.9713 4.67999 15.6Z",
    stroke: "#737C88",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68 15.6C2.52642 15.6 0.779999 18.2184 0.779999 21.45C0.779999 24.68 2.52642 27.3 4.68 27.3",
    stroke: "#737C88",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.76 28.86C32.76 32.76 30.42 35.1 26.52 35.1H23.4",
    stroke: "#737C88",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSupport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/support.8341a5ac.svg";
export { ForwardRef as ReactComponent };